import { siteConfig } from "./config/site";

/** Añade enlace a Instagram en la barra de herramientas del header. */
export function initHeaderInstagramLink(): void {
  for (const tools of document.querySelectorAll(".site-header__tools")) {
    if (tools.querySelector("[data-instagram-link]")) continue;

    const a = document.createElement("a");
    a.href = siteConfig.contact.instagramUrl;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.className = "site-header__icon";
    a.setAttribute("aria-label", `Instagram @${siteConfig.contact.instagramHandle}`);
    a.dataset.instagramLink = "";

    const span = document.createElement("span");
    span.className = "material-symbols-outlined";
    span.setAttribute("aria-hidden", "true");
    span.textContent = "photo_camera";

    a.appendChild(span);
    tools.insertBefore(a, tools.firstChild);
  }
}
